import type { MembershipState } from "@rtr/godmother";
import Constants from "rtr-constants";
import MembershipHelpers from "./membership-helpers";
import availabilityFilterHelpers from "./availability-filter-helpers";
import type { WorkingFilters } from "components/types/working-filters";
import { isStorefrontNext } from "./environment-helpers";

const AVAILABLE_NOW_AVAILABILITY = 1;
const ALL_STYLES_AVAILABILITY = 0;

const { rtrUpdateMinAvailabilityFilterKey, unlimitedMinAvailabilityKey } = availabilityFilterHelpers;

/**
 * Determine if the user is currently viewing only available inventory based on applicable workingFilters.
 */
export const isViewingAvailableOnly = (workingFilters: WorkingFilters, membershipState: MembershipState) => {
  if (isStorefrontNext()) {
    return Boolean(workingFilters.availableOnly);
  } else {
    const hasRtrUpdateInventory = MembershipHelpers.hasInventoryEligibility(
      membershipState,
      Constants.inventoryEligibilities.rtr_update
    );

    // The only group with rtr update availability is the 1-swap user.
    // All other fixed swap and non subs will have rtr unlimted availability.
    const minAvailableFilterGroupKey = hasRtrUpdateInventory
      ? rtrUpdateMinAvailabilityFilterKey
      : unlimitedMinAvailabilityKey;

    return workingFilters[minAvailableFilterGroupKey] === 1;
  }
};

export const getRubySubscriptionAvailabilityFilter = (availableOnly: boolean, isBasicCloset: boolean) => {
  // The only group with rtr update availability is the 1-swap user.
  // All other fixed swap and non subs will have rtr unlimted availability.
  const minAvailableFilterGroupKey = isBasicCloset ? rtrUpdateMinAvailabilityFilterKey : unlimitedMinAvailabilityKey;

  const membershipAvailabilityFilter = {
    [minAvailableFilterGroupKey]: availableOnly ? AVAILABLE_NOW_AVAILABILITY : ALL_STYLES_AVAILABILITY,
  };

  return membershipAvailabilityFilter;
};
